function ReportsService(ApiService) {
  'ngInject';

  const service = {};

  service.getReportExports = function (orgId, url, pageNumber, size, callbackFunc) {
    ApiService.get(url, callbackFunc);
  };

  service.exportProfitAndLoss = function (orgId, params, callbackFunc) {
    ApiService.put(`/organizations/${orgId}/report_exports/export_profit_and_loss`, params, callbackFunc);
  };

  service.emailProfitAndLoss = function (orgId, report_id, clients, callbackFunc) {
    ApiService.post(`/organizations/${orgId}/report_exports/${report_id}/email_client`, {
      clients: clients
    }, callbackFunc);
  };

  return service;
}

export default {
  name: 'ReportsService',
  fn: ReportsService
};
